import { useEffect, useState } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import Base from "../Employee_components/Employee_Base";
import "./EmployeeTree.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs, Link } from "@mui/material";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";
import UseAxios from "../Auth/UseAxios";
import { useAuth } from "../Auth/AuthContext";
import { ClipLoader } from "react-spinners";


const EmployeeTree = () => {
  const [employeeHierarchy, setEmployeeHierarchy] = useState({});
  const [expanded, setExpanded] = useState({});
  const api = UseAxios();
  const { employee } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const designationColors = {
    DO: "#FF5733", // Red
    AGM: "#33FF57", // Green
    GM: "#3357FF", // Blue
    // "DM": "#F4C542", // Yellow
    MO: "#A833FF", // Purple
    Intern: "#FF33A8", // Pink
    // "DM": "#FF8C00", // Orange
    DM: "#008080", // Teal
  };

  // ✅ Fetch All Employees (For Full List)
  const fetchAllEmployees = async () => {
    try {
      const response = await api.get(`${EMPLOYEE_API_BASE_URL}/employee/hierarchy-tree/${employee.employeeReferenceId}`);

      setEmployeeHierarchy(buildHierarchy(response.data)); // ✅ Build the hierarchy tree
      //console.log(response.data, "treeee");
    } catch (error) {
      setError("Error fetching all employees ");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Convert Flat List into Hierarchy Tree
  const buildHierarchy = (employees) => {
    const hierarchy = {};
    const map = {};

    employees.forEach((emp) => {
      map[emp.employeeReferenceId] = {
        ...emp,
        managerReferenceId: emp.manager
          ? emp.manager.employeeReferenceId
          : null,
        subordinates: [],
      };
    });

    employees.forEach((emp) => {
      const managerId = emp.manager ? emp.manager.employeeReferenceId : null;

      if (managerId && map[managerId]) {
        map[managerId].subordinates.push(map[emp.employeeReferenceId]);
      } else {
        hierarchy[emp.employeeReferenceId] = map[emp.employeeReferenceId]; // Top-level managers
      }
    });

    return hierarchy;
  };

  // ✅ Load Data on Mount
  useEffect(() => {
    fetchAllEmployees(); // ✅ Load the entire employee list
  }, []);

  // ✅ Expand/Collapse Function
  const toggleExpand = (id) => {
    setExpanded((prev) => {
      const isCurrentlyExpanded = prev[id];

      if (isCurrentlyExpanded) {
        // Function to reset children recursively
        const resetChildren = (node) => {
          if (!node) return {}; // Ensure node is valid before accessing properties

          let newExpandedState = { [node.employeeReferenceId]: false };
          node.subordinates.forEach((sub) => {
            newExpandedState = { ...newExpandedState, ...resetChildren(sub) };
          });
          return newExpandedState;
        };

        // Find the node in the entire hierarchy
        const findNode = (nodes) => {
          for (let key in nodes) {
            if (nodes[key].employeeReferenceId === id) {
              return nodes[key];
            }
            const found = findNode(nodes[key].subordinates);
            if (found) return found;
          }
          return null;
        };

        const node = findNode(employeeHierarchy);
        return node ? resetChildren(node) : prev;
      } else {
        return { ...prev, [id]: true };
      }
    });
  };




  const renderHierarchy = (nodes) => {
    return Object.values(nodes).map((employee) => {
      const hasChildren = employee.subordinates.length > 0;
      const color = designationColors[employee.designation] || "#000"; // Default black if not mapped

      return (
        <li key={employee.employeeReferenceId} className="tree-item">
          <div
            className="tree-header"
            onClick={() =>
              hasChildren && toggleExpand(employee.employeeReferenceId)
            }
            style={{
              borderLeft: `5px solid ${color}`,
              paddingLeft: "10px",
              //backgroundColor: "EAEAEA", 
              borderRadius: "5px",
              margin: "8px 0",
              // height:"40px"
              width: "60%",

            }}
          >
            {hasChildren &&
              (expanded[employee.employeeReferenceId] ? (
                <FaChevronDown />
              ) : (
                <FaChevronRight />
              ))}
            <span
              className="tree-name"
              style={{ color: color, fontWeight: "bold" }}
            >
              {employee.fullName} ({employee.designation})
            </span>
          </div>

          {expanded[employee.employeeReferenceId] && (
            <ul className="tree-children">
              {renderHierarchy(employee.subordinates)}
            </ul>
          )}
        </li>
      );
    });
  };

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "20px",
            }}
          >
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" href="/employee/dashboard" sx={{ color: "blue", fontWeight: "bold" }}>
                Dashboard
              </Link>
              <Link underline="none" color="inherit" href="/employee/employee_tree" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
                Employee Tree
              </Link>
            </Breadcrumbs>
          </div>
          <h2 className="text-center fw-bold fs-1" style={{ color: "darkslategrey" }}>
            Employee Hierarchy
          </h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} />
          </div>

          <h4 className="text-center" style={{ color: "#333", fontWeight: "bold" }}>
            {employee.fullName} ({employee.designation})
          </h4>

          <div className="tree-container">
            <ul className="tree-list">{renderHierarchy(employeeHierarchy)}</ul>
          </div>
        </>
      )}
    </Base>
  );
};

export default EmployeeTree;
